import { useAppSelector } from '@app/redux/hooks';
import { getActionsByTypeProduct } from '../../module/selectors/getActionsByTypeProduct';
import { ActionBoxByTypeProductTypeProps } from './TypeProps';
import { ScrollBar } from '@components/ui-kit/ScrollBar';
import { ActionItem } from './ActionItem';
import classNames from 'classnames';

import styles from './ActionBoxByTypeProduct.module.scss';

export const ActionBoxByTypeProduct = ({ className }: ActionBoxByTypeProductTypeProps) => {
  const actions = useAppSelector(getActionsByTypeProduct);

  return (
    <div className={classNames(styles.WrapperActionBoxByTypeProduct, className)}>
      <ScrollBar type={'horizontal'} classContainer={styles.Container}>
        {actions
          ?.filter(x => x?.announcePicture)
          ?.slice(0, 8)
          ?.map(item => <ActionItem key={item?.id} {...item} />)}
      </ScrollBar>
    </div>
  );
};
